// Kontensalden postings patch: features/zzKontensaldenPostingsFetchPatch.js (inner chain via luxNativeFetch).
// Outermost fetch: lib/luxFetchDispatcher.js (installLuxFetchDispatcher.js).

const urlParams = new URLSearchParams(window.location.search);
const userName = urlParams.get('userName');
if (userName) {
  localStorage.setItem("userName", userName);
};

// The local reverse proxy still serves /inject.css from the deployed app, so
// it can be stale while inject.js is coming from localhost. Load the matching
// local stylesheet explicitly and bypass the browser cache on every page load.
if (window.location.host === 'app.local.erste-hausverwaltung.de') {
  const localInjectStyles = document.createElement('link')
  localInjectStyles.id = 'lux-local-inject-styles'
  localInjectStyles.rel = 'stylesheet'
  localInjectStyles.href = `http://localhost:3000/inject.css?v=${Date.now()}`
  document.head.appendChild(localInjectStyles)
}

// Kontensalden / account detail: if startDate/endDate are missing from the URL, add them from
// the Lux lock once (location.replace). Do not replace when params exist but differ from the lock —
// the host may strip or rewrite the query and fighting that causes infinite reloads. The session
// guard lux_accbal_url_sync_once is not cleared when both params are present: after replace the host
// may strip the query via pushState/replaceState; clearing the guard would allow another replace and
// an infinite reload loop. Posting fetches are patched in zzKontensaldenPostingsFetchPatch.js to use
// the lock on this route when fromDate/toDate are missing.
function luxLockedRangeDateToIso(s) {
  if (!s || typeof s !== 'string') return null
  const t = s.trim()
  if (/^\d{4}-\d{2}-\d{2}/.test(t)) return t.slice(0, 10)
  const m = t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/)
  if (!m) return null
  const yyyy = m[3]
  const mm = m[2].padStart(2, '0')
  const dd = m[1].padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

function luxApplyLockedRangeToAccountBalancesUrl() {
  try {
    const path = window.location.pathname
    const isAccountDetail =
      /^\/account-balances\/[^/]+\/account\/[^/]+$/.test(path) ||
      /^\/dashboard\/account-sheet\/property\/[^/]+\/account\/[^/]+$/.test(path)
    if (!isAccountDetail) return
    const raw = localStorage.getItem('lux_rangeInput_memory')
    if (!raw) return
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed.startDate !== 'string' || typeof parsed.endDate !== 'string') return
    const isoStart = luxLockedRangeDateToIso(parsed.startDate)
    const isoEnd = luxLockedRangeDateToIso(parsed.endDate)
    if (!isoStart || !isoEnd) return

    const sp = new URLSearchParams(window.location.search)
    const urlStartRaw = sp.get('startDate')
    const urlEndRaw = sp.get('endDate')
    const hasStart = urlStartRaw != null && String(urlStartRaw).trim() !== ''
    const hasEnd = urlEndRaw != null && String(urlEndRaw).trim() !== ''
    if (hasStart && hasEnd) {
      return
    }

    const guardKey = 'lux_accbal_url_sync_once'
    try {
      if (sessionStorage.getItem(guardKey) === path) {
        return
      }
    } catch (_e) {
      /* ignore */
    }

    const url = new URL(window.location.href)
    url.searchParams.set('startDate', isoStart)
    url.searchParams.set('endDate', isoEnd)
    if (url.href === window.location.href) return
    try {
      sessionStorage.setItem(guardKey, path)
    } catch (_e) {
      /* ignore */
    }
    window.location.replace(url.toString())
  } catch (_e) {
    /* ignore */
  }
}

luxApplyLockedRangeToAccountBalancesUrl()

// Host SPA sometimes shows the stock SSO shell without going through the reverse proxy on /login.
// That UI contains this copy; force a real navigation to /login so the proxy can serve Lux.
const LUX_WRONG_LOGIN_SHELL_SNIPPET = 'Ihre unternehmensspezifischen Anmeldeoptionen'
const LUX_LOGIN_PROXY_REDIRECT_KEY = 'lux_login_proxy_redirect_count'
const LUX_LOGIN_PROXY_REDIRECT_MAX = 2

function luxRedirectToLoginForReverseProxy() {
  try {
    const body = document.body
    if (!body) return
    const text = body.innerText || ''
    if (!text.includes(LUX_WRONG_LOGIN_SHELL_SNIPPET)) return

    let n = 0
    try {
      n = parseInt(sessionStorage.getItem(LUX_LOGIN_PROXY_REDIRECT_KEY) || '0', 10) || 0
    } catch (_e) {
      /* ignore */
    }
    if (n >= LUX_LOGIN_PROXY_REDIRECT_MAX) return
    try {
      sessionStorage.setItem(LUX_LOGIN_PROXY_REDIRECT_KEY, String(n + 1))
    } catch (_e) {
      /* ignore */
    }

    window.location.replace(new URL('/login', window.location.origin).href)
  } catch (_e) {
    /* ignore */
  }
}

let luxLoginProxyCheckTimer = null
function luxScheduleLoginProxyCheck() {
  if (luxLoginProxyCheckTimer) return
  luxLoginProxyCheckTimer = setTimeout(() => {
    luxLoginProxyCheckTimer = null
    luxRedirectToLoginForReverseProxy()
  }, 300)
}

let luxLoginProxyObserverInstalled = false
function luxInstallLoginProxyShellObserver() {
  if (luxLoginProxyObserverInstalled || !document.body) return
  luxLoginProxyObserverInstalled = true
  luxScheduleLoginProxyCheck()
  const mo = new MutationObserver(() => {
    luxScheduleLoginProxyCheck()
  })
  mo.observe(document.body, { childList: true, subtree: true })
}

const host = window.location.host
const validHostPattern = /^app(\.[a-z0-9-]+)?\.erste-hausverwaltung\.de$/

const baseApiUrl =
  host === 'app.local.erste-hausverwaltung.de'
    ? 'http://localhost:3000'
    : validHostPattern.test(host)
      ? `https://${host}`
      : 'https://app.dev.erste-hausverwaltung.de';

const activeObservers = {}

const resolveDomain = (domain) => {
  let resolvedDomain = ""
  switch (domain) {
    case 1115:
      resolvedDomain = 'cig'
      break
    case 1044:
      resolvedDomain = 'erste-hausverwaltung-dus'
      break
    case 1116:
      resolvedDomain = 'zieglmeier'
      break
    case 1572:
      resolvedDomain = 'bachem'
      break
    case 1015:
      resolvedDomain = 'hauscon'
      break
    case 949:
      resolvedDomain = 'erste-hausverwaltung-2'
      break
    case 2421:
      resolvedDomain = 'ehv-service'
      break
    case 4637:
      resolvedDomain = 'ehv-test'
      break
    case 2740:
      resolvedDomain = 'verwey-demo'
      break
    case 3265:
      resolvedDomain = 'sgv-murr'
      break
    case 3795:
      resolvedDomain = 'verwey'
      break
    case 2674:
      resolvedDomain = 'hv-tesche'
      break
    case 5217:
      resolvedDomain = 'fraenken'
      break
    case 5153:
      resolvedDomain = 'bhv'
      break
    case 4296:
      resolvedDomain = 'oehler'
      break
    case 5289:
      resolvedDomain = 'benz-walker'
      break
    case 5763:
      resolvedDomain = 'riebeling'
      break
    default:
      resolvedDomain = domain
  }
  return resolvedDomain
};

const initateAnObserver = (onObserve, selector) => {
  if (typeof onObserve !== 'function') return
  if (activeObservers[selector]) {
    activeObservers[selector].disconnect()
    delete activeObservers[selector]
  }

  const observer = new MutationObserver(onObserve)

  observer.observe(document.querySelector('body'), {
    childList: true,
    subtree: true,
  })

  activeObservers[selector] = observer
};

const onElementPresent = (selector, callback) => {
  initateAnObserver(() => {
    const element = $(selector)
    if (element.length) callback(element)
  }, selector)
};

const startLuxInjectRouting = () => {
  const propertyEditPageRegex = /^\/properties\/([A-Za-z0-9]+)\/edit$/

  const onPageChanged = () => {
    luxApplyLockedRangeToAccountBalancesUrl()

    luxInstallLoginProxyShellObserver()

    const pathname = window.location.pathname
    onLuxRentNavigation()

    // pushState/replaceState do not fire popstate; tear down property inject so in-flight
    // guards and observers do not block a later visit to the same property.
    if (!propertyEditPageRegex.test(pathname)) {
      if (typeof window.__impowerxPropertyCleanup === 'function') {
        window.__impowerxPropertyCleanup()
      }
    }

    onAnyPageMatch()

    // Safety check: only proceed if pagesLookupDictionary is defined and initialized
    if (window.pagesLookupDictionary) {
      for (const key in window.pagesLookupDictionary) {
        const { regex, action } = window.pagesLookupDictionary[key]

        if (regex.test(pathname)) {
          setTimeout(() => {
            action(pathname, regex)
          }, 1000)
          return
        }
      }
    }
  }

  window.addEventListener('load', onPageChanged)
  window.addEventListener('popstate', onPageChanged)
  // If navigation cleanup disconnected an inject, its own pageshow listener is gone.
  // Retry routing on restore; the property-page guard skips an intact enhanced form.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) onPageChanged()
  })

  const originalPushState = history.pushState
  const originalReplaceState = history.replaceState

  // Lux pages behind nginx: Impower's client router would otherwise keep the old
  // shell (e.g. /profit-and-loss?administrationTypes=…). Force a full load so
  // nginx can proxy to Lux. /dashboard is exact; /profit-and-loss, the property
  // insurance pages (create, detail) and the technical-asset pages (property- or
  // building-scoped: list, create, detail) include subpaths.
  const isLuxHardNavPath = (pathname) =>
    pathname === '/dashboard' ||
    pathname === '/profit-and-loss' ||
    pathname.startsWith('/profit-and-loss/') ||
    /^\/properties\/[^/]+\/insurances(\/|$)/.test(pathname) ||
    /^\/properties\/[^/]+\/(buildings\/[^/]+\/)?technical-assets(\/|$)/.test(pathname)

  const hardNavigateIfLuxRoute = (url) => {
    if (url == null || url === '') return false
    try {
      const next = new URL(String(url), window.location.origin)
      if (!isLuxHardNavPath(next.pathname)) return false
      window.location.href = `${next.pathname}${next.search}${next.hash}`
      return true
    } catch {
      return false
    }
  }

  history.pushState = (state, title, url) => {
    if (hardNavigateIfLuxRoute(url)) return
    originalPushState.call(history, state, title, url)
    onPageChanged()
  }

  history.replaceState = (state, title, url) => {
    if (hardNavigateIfLuxRoute(url)) return
    originalReplaceState.call(history, state, title, url)
    onPageChanged()
  }

  // Document may already be loaded when inject.js arrives late.
  if (document.readyState === 'complete') {
    onPageChanged()
  }
}

// Defer one macrotask so the rest of the gulp concat (escapeHtml, page maps, …) has run.
// Do NOT wait on cdnjs — corporate firewalls often hang that request forever.
setTimeout(startLuxInjectRouting, 0)
